import { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom"
import { useWindowSize } from "../../../hooks/useWindowSize";
import SideBar from "../sidebar"

import Dropdown from 'react-bootstrap/Dropdown';

import Noti from "../../../assets/noti-1.png"
import User1 from "../../../assets/user.png"
import DropIco from "../../../assets/drop-ico.png"
import Menu2 from "../../../assets/icons/menu.png"
import ShopGrIco from "../../../assets/icons/shop_gr.png"
import LocationIco from "../../../assets/icons/location.png"
import InfoErrorIco from "../../../assets/icons/info_error.svg"
import "./index.scss";


export const AppHeader = (props: any) => {
    const screenResolution: any = useWindowSize();
    const [isMobileMenuVisible, setShowVisible] = useState<boolean>(false)
    let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    // console.log("screenResolution", screenResolution)


    const handleLoadStore = (storeId: any) => {
        let allStores: any[] = loggedAccountInfo?.myStores || [];
        let filteredStore = allStores.filter((eachStore: any) => eachStore.id === storeId)[0]
        loggedAccountInfo.selectedStore = filteredStore;
        localStorage.setItem("mamiVendorXAuth", JSON.stringify(loggedAccountInfo));

        window.location.reload();
    }
    return (
        <div className="header-wrap">


            {screenResolution?.width >= 768 &&
                <div className="header-menus">
                    {/* <div className="each-menu">
                        <img src={Noti} alt="" />
                    </div>
                    <div className="each-menu">
                        <img src={ProfileIco} alt="" />
                    </div> */}
                    {props?.noStores &&
                        <div className="store_info">
                            <div className="store-name">
                                Review ongoing
                            </div>
                            {/* <div className="store-location">
                                
                            </div> */}
                        </div>
                    }
                    {(loggedAccountInfo?.selectedStore && !props?.showMainPageHeading && loggedAccountInfo?.selectedStore?.hasBankLinked === false) &&
                        <div className="nobank_linked">
                            <img src={InfoErrorIco} alt="" />
                            <div className="bank_txt">
                                Please note that your store will not be visible to customers until you add a withdrawal method.
                                <Link to={`/app/profile/withdrawal`}> Add now</Link>
                            </div>
                        </div>
                    }
                    {(loggedAccountInfo?.selectedStore && !props?.showMainPageHeading && loggedAccountInfo?.selectedStore?.hasBankLinked === true) &&
                        <div className="store_info">
                            <div className="store-name">
                                <img src={ShopGrIco} />
                                {loggedAccountInfo?.selectedStore?.name}
                            </div>
                            <div className="store-location">
                                <img src={LocationIco} />
                                {loggedAccountInfo?.selectedStore?.address?.city ? "," : ""} {loggedAccountInfo?.selectedStore?.address?.province || loggedAccountInfo?.selectedStore?.address?.country}
                            </div>
                        </div>
                    }
                    {(loggedAccountInfo?.selectedStore && props?.showMainPageHeading && props?.mainPageHeading && loggedAccountInfo?.selectedStore?.hasBankLinked === true) &&
                        <div className="page-heading-content">
                            {props?.mainPageHeading}
                        </div>
                    }
                    <div className="other_items">
                        <div className="notify-cta">
                            <img src={Noti} alt="" />
                        </div>
                        <div className="profile-info">
                            <div className="profile-store-name">
                                <div className="name-ofuser">{loggedAccountInfo?.userProfile?.firstName} {loggedAccountInfo?.userProfile?.lastName}</div>
                                <div className="name-ofstore">{loggedAccountInfo?.selectedStore?.name}</div>
                            </div>
                            <div className="">
                                <Dropdown>
                                    <Dropdown.Toggle id="dropdown-basic" className="profile-img-drop">
                                        <img src={User1} alt="" className="user-img" />
                                        <div className="drop-ico">
                                            <img src={DropIco} />
                                        </div>
                                    </Dropdown.Toggle>
                                    {loggedAccountInfo?.myStores &&
                                        <Dropdown.Menu>
                                            <Dropdown.Item disabled={true} className="stores-heading">Stores</Dropdown.Item>
                                            {loggedAccountInfo?.myStores.map((eachStore: any, index: any) => {
                                                return (
                                                    <Dropdown.Item className="store-brief" key={index} onClick={() => handleLoadStore(eachStore?.id)}>
                                                        <div className="store-logoico"><img src={eachStore?.logoUrl} alt="" /></div>
                                                        <div className="store-name-location">
                                                            <div className="store-name-text">{eachStore?.name}</div>
                                                            <div className="store-location-text">
                                                                {eachStore?.address?.city}, {eachStore?.address?.province || eachStore?.address?.country}
                                                            </div>
                                                        </div>
                                                    </Dropdown.Item>
                                                )
                                            })
                                            }
                                            <Dropdown.Item className="add-new-store"> + Add a new store <span>coming soon</span></Dropdown.Item>

                                            {/* < Dropdown.Item className="store-brief">Store 2</> */}
                                        </Dropdown.Menu>
                                    }
                                </Dropdown>

                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                screenResolution?.width <= 767 &&
                <div className="header-menus" onClick={() => setShowVisible(true)}>
                    <div className="each-menu small">
                        <img src={Menu2} alt="" />
                    </div>
                </div>
            }
            {
                isMobileMenuVisible &&
                <SideBar
                    setShowVisible={setShowVisible}
                    isMobile={isMobileMenuVisible}
                />
            }
        </div >
    )
}
// const mapDispatchToProps = {
// };

// const mapStateToProps = (state: any) => {
//     return {
//         // loginRequest: state.onboardingOutboundReducers.loginReducer,
//     };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(HeadeWrap);